var render, staticRenderFns
import script from "./baseForm2.vue?vue&type=script&lang=js"
export * from "./baseForm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e92fe18')) {
      api.createRecord('3e92fe18', component.options)
    } else {
      api.reload('3e92fe18', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/baseForm2.vue"
export default component.exports